import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getDashboardCustomerCountList = createAsyncThunk(
  "dashboardCustomerCountList/getDashboardCustomerCountList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/customer/dashboard`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const dashboardCustomerCountSlice = createSlice({
  name: "dashboardCustomerCountList",
  initialState: {
    loading: false,
    dashboardCustomerCountData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardCustomerCountList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardCustomerCountList.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardCustomerCountData = action.payload;
      })
      .addCase(getDashboardCustomerCountList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default dashboardCustomerCountSlice.reducer;
